<template>
  <cTable
    ref="table"
    :fields="fields"
    :modals="modals"
    :header="header"
    :methods="methods"
  >
  </cTable>
</template>

<script>
import {
  getList,
  save,
  del
} from "@/api/operation_modules/faq";
import cTable from "@/base/common/index";
export default {
  name: "faq",
  components: {
    cTable,
  },
  mounted() {},
  methods: {
  },
  data() {
    return {
      addId: 0,
      isRead: false,
      methods: {
        list: p => {
          return getList(p);
        },
        save,
        del
      },
      modals: {
        add: {
          methods: {
            ok({ row, close, btn }) {
              this.$page.handleRequestMethods("save", row, true,true).then(e => {
                this.$page.getList();
              });
            },
          },
          config: {
            modalBind: {
              width: "880",
              // "class-name": "vertical-center-modal",
              draggable: true,
              sticky: true,
              scrollable: true,
            },
            formBind: {
              labelWidth: 120
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              title_cn: [
                {
                  required: true,
                  type: "string",
                  message: "name cannot be empty",
                  trigger: "blur"
                }
              ],
              title_en: [
                {
                  required: true,
                  type: "string",
                  message: "content cannot be empty",
                  trigger: "change"
                }
              ],
			  content_cn: [
			    {
			      required: true,
			      type: "string",
			      message: "content cannot be empty",
			      trigger: "change"
			    }
			  ],
			  content_en: [
			    {
			      required: true,
			      type: "string",
			      message: "content cannot be empty",
			      trigger: "change"
			    }
			  ]
            }
          },
          grid: [{ title_cn: 24 }, { title_en: 24 }, { content_cn: 24 }, { content_en: 24 }, { sort: 24 }],
          fields: [
            {
              key: "title_cn",
              name: () => this.$t("title_cn"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("title_cn");
              }
            },
            {
              key: "title_en",
              name: () => this.$t("title_en"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("title_en");
              }
            },
			{
				key: "content_cn",
				name: () => this.$t("content_cn"),
				component: "Input",
				placeholder() {
					return this.$t("enter") + this.$t("content_cn");
				},
				bind: {
				  type: "textarea",
				  rows: 3
				},
			},
			{
				key: "content_en",
				name: () => this.$t("content_en"),
				component: "Input",
				placeholder() {
					return this.$t("enter") + this.$t("content_en");
				},
				bind: {
				  type: "textarea",
				  rows: 3
				},
			},
			{
			  key: "sort",
			  name: () => this.$t("sort"),
			  component: "InputNumber",
				default:99,
			  placeholder() {
				return this.$t("enter") + this.$t("sort");
			  },
			  bind: {
			    style:'width:100%'
			  },
			},
          ]
        },
      },
      header: {
        config: {
          custom: false
        },
        searchs: [
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("start") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "date",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              format({ searchForm, value, newFormData }) {
                return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              }
              // "on-change"({ searchForm }) {
              //   searchForm.startTime = searchForm.startTime
              //     ? this.$page.format.timeFormat(searchForm.startTime)
              //     : "";
              // }
            }
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("end") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "date",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              format({ searchForm, value, newFormData }) {
                return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              }
              // "on-change"({ searchForm }) {
              //   let time = this.$page.format.timeFormat(searchForm.endTime);
              //   if (time.slice(-8) === "00:00:00") {
              //     time = time.split(" ")[0] + " " + "23:59:59";
              //     searchForm["endTime"] = time;
              //   }
              // }
            }
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              type: "textarea",
              rows: 1
            },
            component: "Input"
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "addFun",
              bind: {
                type: "warning",
                icon: "md-add"
              }
            }
          ],
          methods: {
            addFun({ field, searchForm }) {
              this.$parent.addId = 0;
              console.log(this);
              this.getModal("add").open(
                {
                  content: "",
                  files: []
                },
                function() {
                  this.setTitle(this.$t("add"));
                }
              );
            }
          }
        }
      },
      fields: [
        {
          name: () => this.$t("title_cn"),
          key: "title_cn",
          align: "center",
          minWidth: 150
        },
		{
		  name: () => this.$t("title_en"),
		  key: "title_en",
		  align: "center",
		  minWidth: 150
		},
        {
          name: () => this.$t("content_cn"),
          key: "content_cn",
          align: "center",
          minWidth: 120
        },
        {
          name: () => this.$t("content_en"),
          key: "content_en",
          align: "center",
          minWidth: 120
        },
		{
		  name: () => this.$t("sort"),
		  key: "sort",
		  align: "center",
		  minWidth: 120
		},
		{
		  name: () => this.$t("Remarks"),
		  key: "remark",
		  align: "center",
		  minWidth: 120
		},
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          align: "center",
          minWidth: 120
        },
        {
          type: "btns",
          width: 200,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success"
              },
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "deleteFun",
              bind: {
                type: "error"
              },
            }
          ],

          methods: {
            async update({ row }) {
              this.getModal("add").open(row, function() {
                this.setTitle(row.title);
              });
            },
            deleteFun({ row }) {
              this.$Modal.confirm({
                title:
                  this.$t("whether") +
                  this.$t("confirm") +
                  this.$t("delete") +
                  "：" +
                  row.title +
                  "?",
                onOk: () => {
                  this.handleRequestMethods(
                    "del",
                    {
                      id: row.id,
                    },
                    true
                  ).then(res => {
                    // this.$Message.success(res.data.msg);
                    this.getList();
                  });
                }
              });
            }
          }
        }
      ]
    };
  }
};
</script>
<style>
/* .bulletin-tit .ivu-modal-header-inner {
  text-align: center;
  height: 26px;
  line-height: 26px;
  font-size: 20px;
} */
</style>
